<div class="lg:bg-gray-100 lg:dark:bg-[#020617] flex flex-col w-full h-full justify-center items-center"
  *ngIf="user$ | async as user">
  <div class="hidden lg:flex"><app-black-friday-banner></app-black-friday-banner></div>
  <app-top-banner-ad></app-top-banner-ad>
  <div
    class="footer-wrap relative w-full h-full flex flex-col max-w-[568px] justify-start items-center bg-gray-50 dark:!bg-slate-900 lg:box-content lg:px-12 lg:shadow-2xl"
    *ngIf="state$ | async as state">
    <div class="w-full relative lg:!pt-0" [ngClass]="{
        'pt-24' : state.topAdOpen && !user?.premiumGames?.includes('wheretaken'),
        'pt-4' : !state.topAdOpen}">
      <div class="lg:hidden"><app-black-friday-banner></app-black-friday-banner></div>
      <div class="container">
        <div class="absolute z-50">
          <app-alert class="alert" *ngIf="state.showAlert"></app-alert>
        </div>
        <app-header></app-header>
        <div *ngIf="archive$ | async as archive">
          <div *ngIf="archive.isArchiveGame"
            class="flex flex-col items-center justify-center mt-2 bg-slate-200 px-2 py-1 rounded-md shadow-md">
            <p class="text-sm font-bold">Archive mode</p>
            <a class="cursor-pointer text-blue-600 text-xs" (click)="returnToToday()">Return to today's game</a>
          </div>
        </div>
        <router-outlet></router-outlet>
        <div class="sidebar-ad-desktop flex flex-col items-center" *ngIf="!user?.premiumGames?.includes('wheretaken')">
          <a routerLink="/passport" class="remove-ads-cta mb-1">
            Remove ads
            <span class="remove-ads-cta__icon">
              <img src="/assets/icons/teuteuf_passport.png" width="14" height="14" alt="" />
            </span>
          </a>
          <div id="adngin-sidebar_left-0"></div>
          <div id="adngin-sidebar_bottom-0"></div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
    <app-faq-section class="mb-8 px-4 text-slate-900 dark:text-slate-100"></app-faq-section>
  </div>
  <div id="adngin-video-0" *ngIf="!user?.premiumGames?.includes('wheretaken')"></div>
</div>
<br>